import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import OutsideAlerter from "../outsideAlerter";
import Input from "../input";
import styles from "./autocomplete.scss";

export default function Autocomplete({
  suggestions,
  filterSuggestions,
  onSelect,
  inputValue,
  onChange,
  placeholder,
  getValue,
  onInputFocus,
  autoSelect,
  noElementFoundMessage,
  getSubValue,
  showSubValue,
  ...optionalProps
}) {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  useEffect(() => {
    if (!filterSuggestions) {
      setFilteredSuggestions(suggestions);
    } else {
      const filtered = suggestions.filter((suggestion) => getValue(suggestion).toLowerCase().includes(inputValue.toLowerCase()));
      setFilteredSuggestions(filtered);
      // AutoSelect : one remaining suggestion key value = input Value
      if (autoSelect && filtered.length === 1 && inputValue && filtered[0].key === inputValue) onSelect(filtered[0]);
    }
    // setShowSuggestions(!!suggestions.length && !!inputValue.length);
  }, [suggestions, inputValue]);

  const onFocus = () => {
    onInputFocus();
    setShowSuggestions(true);
  };

  const onInputChange = (value) => onChange(value);

  const onSelectSuggestion = (suggestion) => {
    setShowSuggestions(false);
    onSelect(suggestion);
  };

  const handleOnOutsideClick = () => {
    setShowSuggestions(false);
  };

  return (
    <OutsideAlerter onOutsideClick={handleOnOutsideClick}>
      <div className={styles.autocompletewrap}>
        <Input {...optionalProps} value={inputValue} onChange={onInputChange} placeholder={placeholder} onFocus={onFocus} />
        {showSuggestions && !!suggestions?.length && (
          <ul className={styles.autocompletelist}>
            {filteredSuggestions.map((suggestion, index) => (
              <li key={index} onClick={() => onSelectSuggestion(suggestion)}>
                <div>{getValue(suggestion)}</div>
                {showSubValue && <div>{getSubValue(suggestion)}</div>}
              </li>
            ))}
            {noElementFoundMessage && !filteredSuggestions.length && (
              <span className={styles.noElementFoundMessage}>{noElementFoundMessage}</span>
            )}
          </ul>
        )}
      </div>
    </OutsideAlerter>
  );
}

Autocomplete.defaultProps = {
  inputValue: "",
  suggestions: [],
  autoSelect: true,
  placeholder: "Search",
  noElementFoundMessage: "",
  filterSuggestions: false,
  onChange: () => {},
  onSelect: () => {},
  onInputFocus: () => {},
  getValue: (value) => value,
  getSubValue: (value) => value,
  showSubValue: false,
};

Autocomplete.propTypes = {
  suggestions: PropTypes.array,
  filterSuggestions: PropTypes.bool,
  onSelect: PropTypes.func,
  inputValue: PropTypes.string,
  onChange: PropTypes.func,
  onInputFocus: PropTypes.func,
  placeholder: PropTypes.string,
  getValue: PropTypes.func,
  autoSelect: PropTypes.bool,
};
